import * as crosshairJs from './crosshair.js';

export function getCrosshairContainer(origCode) {
	if (origCode === false) {
		console.error('invalid code: ' + origCode);
		return false;
	}
	const code = crosshairJs.validateCrosshair(origCode);
	if (!code) {
		console.error('invalid code: ' + code);
		return false;
	}

	const container = document.createElement('DIV');
	container.classList.add('x-hair-container');

	const xhair = document.createElement('X-HAIR');
	xhair.attr_code = code;
	container.appendChild(xhair);

	if (!loadCrosshair(container, xhair)) {
		return false;
	}
	return container;
}

function loadCrosshair(container, xh) {
	if (!xh.attr_code)
		return false;

	const code = xh.attr_code;

	try {
		const canvas = crosshairJs.generateCrosshair(code);
		if (canvas === false)
			return false;

		xh.appendChild(canvas);
		return true;
	} catch (error) {
		console.error('Invalid crosshair code: ' + code);
		console.error(error);
	}
	return false;
}
